import React, { useState } from "react";
import UpgradeModal from "./UpgradeModal";

interface UpgradeBannerProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onUpgrade?: () => void;
}

/**
 * UpgradeBanner - Reusable promotional banner for free plan users
 * Features purple gradient background with brutalist styling
 */
const UpgradeBanner: React.FC<UpgradeBannerProps> = ({
  title = "Upgrade to PRO for Automated Workflows",
  subtitle = "Set up recurring weekly or monthly updates with AI-generated insights",
  buttonText = "UPGRADE TO PRO",
  onUpgrade,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleUpgrade = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <div className="su-upgrade-banner">
      {/* Gradient overlay for depth */}
      <div className="su-upgrade-banner-gradient" />
      
      {/* Content */}
      <div className="su-upgrade-banner-inner">
        <div className="su-upgrade-banner-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
          </svg>
        </div>
        <div className="su-upgrade-banner-content">
          <div className="su-upgrade-banner-title">{title}</div>
          <div className="su-upgrade-banner-subtitle">{subtitle}</div>
        </div>
        <button className="su-upgrade-banner-btn" onClick={handleUpgrade}>
          {buttonText}
        </button>
      </div>

      {/* Upgrade Modal */}
      <UpgradeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>
  );
};

export default UpgradeBanner;
